<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">Loyalty Overview Report</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-4 col-xl-3 align-self-center mb-3" v-if="false">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("To Date") }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getLoyaltyOverView()"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="Records.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getLoyaltyOverView('Y')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="swc-report">
        <!-- Loyality Overview Report -->
        <table class="swc-report-table w-100 mt-2" border="1">
          <tr class="bg-lightgrey font-weight-bold">
            <td rowspan="3" class="text-center">Cinema</td>
            <td colspan="7" class="text-center">Loyalty Overview Report</td>
          </tr>
          <tr class="bg-lightgrey font-weight-bold">
            <td colspan="3" class="text-center">Points Given</td>
            <td colspan="3" class="text-center">Points Redeemed</td>
            <td rowspan="2" class="text-center">Balance</td>
          </tr>
          <tr class="bg-lightgrey font-weight-bold">
            <td class="text-center">Ticket</td>
            <td class="text-center">FNB</td>
            <td class="text-center">Total</td>
            <td class="text-center">Ticket</td>
            <td class="text-center">FNB</td>
            <td class="text-center">Total</td>
          </tr>
          <template v-if="Records.length > 0">
            <tr v-for="(singleRecord, index) in Records" :key="index">
              <td class="text-left">
                <span
                  class="icon-eye mr-1"
                  @click="
                    goToRoute(
                      '/reports/loyalty-settlement-report',
                      singleRecord
                    )
                  "
                ></span>
                &nbsp;
                {{ singleRecord.cinema_name }}
              </td>
              <td class="text-right">
                {{ parseInt(singleRecord.credit_ticket_points) }}
              </td>
              <td class="text-right">
                {{ parseInt(singleRecord.credit_fnb_points) }}
              </td>
              <td class="text-right">
                {{ parseInt(singleRecord.total_earned) }}
              </td>
              <td class="text-right">
                {{ parseInt(singleRecord.debit_ticket_points) }}
              </td>
              <td class="text-right">
                {{ parseInt(singleRecord.debit_fnb_points) }}
              </td>
              <td class="text-right">
                {{ parseInt(singleRecord.total_deducted) }}
              </td>
              <td class="text-right">
                {{ parseInt(singleRecord.balance) }}
              </td>
            </tr>
            <tr class="bg-lightgrey font-weight-bold">
              <td class="text-left">Total</td>
              <td class="text-left">
                {{
                  parseInt(
                    Records.reduce((acc, { credit_ticket_points }) => {
                      return acc + +parseFloat(credit_ticket_points || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-left">
                {{
                  parseInt(
                    Records.reduce((acc, { credit_fnb_points }) => {
                      return acc + +parseFloat(credit_fnb_points || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-left">
                {{
                  parseInt(
                    Records.reduce((acc, { total_earned }) => {
                      return acc + +parseFloat(total_earned || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-left">
                {{
                  parseInt(
                    Records.reduce((acc, { debit_ticket_points }) => {
                      return acc + +parseFloat(debit_ticket_points || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-left">
                {{
                  parseInt(
                    Records.reduce((acc, { debit_fnb_points }) => {
                      return acc + +parseFloat(debit_fnb_points || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-left">
                {{
                  parseInt(
                    Records.reduce((acc, { total_deducted }) => {
                      return acc + +parseFloat(total_deducted || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-left">
                {{
                  parseInt(
                    Records.reduce((acc, { balance }) => {
                      return acc + +parseFloat(balance || 0);
                    }, 0)
                  )
                }}
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="8">
                <NoRecords />
              </td>
            </tr>
          </template>
        </table>
        <!-- Loyality Overview Report -->
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      Records: [],
      ProductInfoRecords: [],
      excelFilePath: "",
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.getCinemaList(obj);
  },
  watch: {
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    moment,
    goToRoute: function (path, item) {
      const { cinema_id } = item;
      this.$router.push({
        path: path,
        query: {
          cinema_id: cinema_id,
          fromDate: moment(this.fromDate).format("YYYYMMDD"),
          toDate: moment(this.toDate).format("YYYYMMDD"),
        },
      });
    },
    getCinemaList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getLoyaltyOverView(isExcelDownload = "N") {
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      } else if (!this.toDate) {
        return this.$toasted.show("Select To Date");
      } else if (
        moment(moment(this.fromDate).format("YYYY-MM-DD")).isAfter(
          moment(this.toDate).format("YYYY-MM-DD")
        )
      ) {
        return this.$toasted.show("From Date is Greater Than TO Date");
      } else {
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId || null,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
        };

        if (isExcelDownload == "Y") {
          payload["isExcel"] = "Y";
        }
        ReportsService.getLoyaltyOverView(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.excelPath && isExcelDownload == "Y") {
              window.open(data.excelPath, "_blank");
            } else if (data.status) {
              this.Records = [...data.Records];
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      }
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/LoyalityOverviewReport.vue